import FeatureController from '../FeatureController';
import { EmojiButton } from '@joeattardi/emoji-button';

export default class MessagesController extends FeatureController{

    constructor (panel, $state, $scope, translateFilter) {
      super(panel, $state);

      const self = this;
      this.scope = $scope;
      this.talk = {};
      this.tracking = {};
      this.fetch_old_messages = true;
      this.translateFilter = translateFilter;
      this.scrollWindow = true;
      this.loadStatusMessage = translateFilter('Fetch older ... ');

      this.loadInbox();

      const socketManager = this.panel.getSocketManager();
      this.ws = socketManager.getSocket(this.panel.socketAddress.PUSH);
      this.serviceHandler = socketManager.getHandler(this.panel.socketAddress.PUSH);
      if (this.serviceHandler) {
        this.serviceHandler.addListener(this.panel.event.MESSAGE, (response) => {
          this.scrollWindow = true;
          if (panel.okay(response)) {
            let msg = response.message;
            if (self.talkingTo !== msg.recipient && self.talkingTo !== msg.sender) {
              // TODO: notification
            } else {
              self.messageHandler(msg);
              $("#instantMessage").trigger('click');
            }
          } else {
            self.panel.handle(response);
          }
        });

        this.serviceHandler.addListener(this.panel.event.TYPING, (response) => {
          console.log(response);
        });
      }
    }

    loadInbox () {
      if (this.$state.params.person) {
        this.set_conversation('messages', this.$state.params.person);
      } else {
        this.isLoading = true;
        const self = this;
        this.panel.get('/v1/inbox/overview', (response) => {
          if (self.panel.okay(response)) {
            if (self.panel.isMobile()) {
              $('#view-inbox-overview').show();
              $('#view-inbox-chat').hide();
            }
            self.isLoading = false;
            localStorage.setItem('messages_init_data', JSON.stringify(response.data));
            self.setData(response.data);
          }
        });
      }
    }

    setData (data) {
      this.folder = data.folder;
      this.person = data.person;
      this.conversations = data.conversations;
      this.requests = data.requests;
    }

    messageHandler (msg) {
      if (!this.talk[this.talkingTo]) {
        this.talk[this.talkingTo] = {'conversation': {}};
      }

      if (!msg.date_year && msg[Object.keys(msg)[0]].hasOwnProperty('date') && msg[Object.keys(msg)[0]].hasOwnProperty('chat')) { // this is an entire conversation
        for (let i in msg) {
          if (!this.talk[this.talkingTo]['conversation'].hasOwnProperty(i)) {
            this.talk[this.talkingTo]['conversation'][i] = msg[i];
            let item = {};
            item[i] = {};
            this.updateTracking(this.talkingTo, item);
          } else {
            let newMessages = msg[i].chat;
            for (let j in newMessages) {
              this.talk[this.talkingTo]['conversation'][i].chat.unshift(newMessages[j]);
            }
          }
        }
      } else if (msg.date_year) { // this is a regular message
        if (!this.talk[msg.recipient]['conversation'][msg.date_year]) {
          this.talk[this.talkingTo]['conversation'][msg.date_year] = {'chat': [], 'date': msg.date};
          let item = {};
          item[msg.date_year] = {};
          this.updateTracking(this.talkingTo, item, true);
        }
        this.talk[this.talkingTo].conversation[msg.date_year].chat.push(msg);
      }
      return true;
    };

    load (load, next) {
      $('.chat-people-switch.'+load).addClass('selected');
      $(".chat-people-list."+load).removeClass('hidden');
      if(window.location.href.indexOf(load) === -1)  history.pushState(null, null, "/inbox/"+load);
      $('.chat-people-switch:not(.'+load).removeClass('selected');
      $(".chat-people-list:not(."+load+")").addClass('hidden');
      const self = this;
      if(next) {
          this.panel.post('/v1/inbox', {q: load}, (response) => {
              if (self.panel.okay(response)) {
                  if (typeof self[load] != 'undefined') {
                      self[load] = self[load].concat(response[load]);
                  }
                  else {
                      self[load] = response[load];
                  }
              }
          });
      }
    };

    set_conversation (folder, screen_name) {
      const self = this;

      this.talkingTo = screen_name;

      this.setData(JSON.parse(localStorage.getItem('messages_init_data')));

      this.panel.post('/v1/inbox/load', {sender:screen_name}, (response) => {
        if (self.panel.isMobile()) {
          $('#view-inbox-overview').hide();
          $('#view-inbox-chat').show();
        }
        self.keyboardPlaceHolder();

          if (!self.talk) self.talk = {};

          self.talk[screen_name] = {
            'meta': response.meta,
            'conversation': response.conversation
          };
          self.updateTracking(screen_name, response.conversation);
      });

      /*
      if(!this.meetup) this.meetup = {};

      this.panel.get('/v1/api?query=meetup&person=' + talk.screen_name, (response) => {
          if (self.panel.okay(response)) this.meetup = response.meetup;
      });
      */
    };

  updateTracking (screen_name, conversation, push) {
    let keys = Object.keys(conversation);
    if (!this.tracking[screen_name]) {
      this.tracking[screen_name] = keys;
    } else {
      if (!push) {
        for (let i in keys) {
          this.tracking[screen_name].unshift(keys[i]);
        }
      } else {
        for (let i in keys) {
          this.tracking[screen_name].push(keys[i]);
        }
      }
    }
  }

  scroll () {
    if (this.scrollWindow) {
      let d = $('#view-inbox-chat .chat-object-info');
      d.scrollTop(d.prop("scrollHeight"));
    }
  }

  load_previous_messages () {
      const self = this;
      if (!this.isLoadingPrev && this.fetch_old_messages) {
        this.isLoadingPrev = true;
        let oldLoadStatusMessage = this.loadStatusMessage;
        this.loadStatusMessage = this.translateFilter('Loading ... ');
        let conversation = this.talk[this.talkingTo]['conversation'];
        let lastMessage = conversation[this.tracking[this.talkingTo][0]].chat[0];
        this.scrollWindow = false;
        this.panel.post('/v1/inbox/load', {'from': this.talkingTo, oldest: lastMessage.message_id}, (response) => {
          if (self.panel.okay(response)) {
            if (response.conversation) {
              if (self.messageHandler(response.conversation)) {
                self.isLoadingPrev = false;
                self.loadStatusMessage = oldLoadStatusMessage;
              }
            } else {
              self.loadStatusMessage = 'No more messages ';
              self.fetch_old_messages = false;
            }
          }
        });
      }
  };

  get_meta (name, screen_name) {
    if (!this.talk[screen_name]){
      return;
    }
    for (let i in this.talk[screen_name].meta) {
        if (this.talk[screen_name].meta[i].screen_name === screen_name) {console.log(this.talk[screen_name].meta[i][name]);
            return this.talk[screen_name].meta[i][name];
        }
    }
  };

  isFirstMessageFromSender (sender, chatIndex, messageIndex) {
    if (this.talk[sender]) {
      if (messageIndex === 0) return true;
      let chat = this.talk[sender].conversation[chatIndex].chat;
      let prevMessageIndex = messageIndex - 1;
      if (chat[prevMessageIndex].sender !== sender) return true;
    }
    return false;
  };

    send_fk_enter_msg (){};

    keyboardPlaceHolder (clear) {

      $(document).ready(() => {
        let im = $("#instantMessage");

        const button = document.querySelector('#emoji-button');
        const picker = new EmojiButton();

        picker.on('emoji', emoji => {
          this.checkText();
          let html = im.html();
          im.html(html+emoji.emoji);
        });

        button.addEventListener('click', () => {
          picker.pickerVisible ? picker.hidePicker() : picker.showPicker(button);
        });

        let content = im.html();

        if (!content || content.trim() === '') {
          let placeholder = $('<small class="placeholder">Write a message</small>');
          im.html(placeholder);
        }
      });
    }

    checkText() {
      let placeholder = $("#instantMessage").find('.placeholder');
      if (placeholder) {
        placeholder.remove();
      }
    }

  send_message (recipient) {
    this.scrollWindow = true;
    const self = this;

    let im = $("#instantMessage").text();

    if (im.trim() === '') {
      this.keyboardPlaceHolder();
      return;
    }

    let msg = {message: im, recipient: recipient};

    self.keyboardPlaceHolder(true);

    if (this.ws && this.ws.connected) {
      msg.sender = this.panel.getUser().register_id;
      this.serviceHandler.emit(this.panel.event.MESSAGE, msg);
    } else {
      this.panel.post('/v1/inbox/chat', msg, (response) => {
        if (self.panel.okay(response)) {
          self.messageHandler(response.message);
        } else {
          self.panel.handle(response);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/features/inbox/MessagesController.js